import React from 'react'

const StudentPage = () => {
  return (
    <div>StudentPage</div>
  )
}

export default StudentPage